import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';

const MAX_STORAGE_BYTES = 50 * 1000 * 1000 * 1000; // 50 GB

const formatGigabytes = (bytes) => {
    return (bytes / 1e9).toFixed(2);
};

const SizeBar = ({ media }) => {
    const usedBytes = media?.reduce((sum, item) => sum + (item?.size || 0), 0) || 0;
    const percent = Math.min(100, Math.round((usedBytes / MAX_STORAGE_BYTES) * 10000) / 100);

    return (
        <Box sx={{ mb: 4, p: 2, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: '8px' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="body2" sx={{ fontWeight: 800, color: 'primary.main' }}>
                    {percent}% belegt
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.secondary' }}>
                    {formatGigabytes(MAX_STORAGE_BYTES - usedBytes)} GB frei
                </Typography>
            </Box>
            <LinearProgress
                variant="determinate"
                value={percent}
                sx={{
                    height: 10,
                    borderRadius: '8px',
                    mt: 2,
                    bgcolor: 'rgba(190, 242, 100, 0.12)',
                    '& .MuiLinearProgress-bar': {
                        borderRadius: '8px',
                        bgcolor: 'primary.main'
                    }
                }}
            />
        </Box>
    );
};

export default SizeBar;
